import React, { useState } from "react";
import { Modal, message } from "antd";
import { useChat } from "./ChatContext";
import UserPicker from "./UserPicker";
import { CHAT_MODAL_Z_INDEX } from "./types";
import { logZulipInvited } from "@/services/app/tenant/integration/zulipChannels";

const InviteMembersModal: React.FC = () => {
  const { inviteTarget, setInviteTarget, invite } = useChat();
  const [userIds, setUserIds] = useState<number[]>([]);
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    setInviteTarget(null);
    setUserIds([]);
  };

  const handleOk = async () => {
    if (!inviteTarget || userIds.length === 0) {
      close();
      return;
    }
    setSubmitting(true);
    try {
      await invite(inviteTarget.name, userIds);
      message.success("Invitation sent.");
      // Best-effort audit log — invite() talks to Zulip directly with the
      // member's own credentials, bypassing our backend entirely.
      logZulipInvited(inviteTarget.stream_id, userIds);
      close();
    } catch (e: any) {
      message.error(e?.message || "Failed to invite members.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={inviteTarget ? `Invite people to #${inviteTarget.name}` : "Invite people"}
      open={!!inviteTarget}
      onOk={handleOk}
      onCancel={close}
      confirmLoading={submitting}
      okText="Invite"
      destroyOnClose
      zIndex={CHAT_MODAL_Z_INDEX}
    >
      <UserPicker value={userIds} onChange={setUserIds} placeholder="Search people to invite…" />
    </Modal>
  );
};

export default InviteMembersModal;
